import React from "react";

const RowsPerPage = ({
  value,
  onChange,
  options = [10, 50, 100],
}) => {
  return (
    <div className="modern-rows-wrapper">

      {/* LEFT */}
      <div className="modern-rows-left">

        <div className="rows-icon">
          <i className="ti ti-layout-rows"></i>
        </div>

        <div className="rows-text-wrap">
          <span className="rows-title">
            Rows per page
          </span>

          <small>
            Customize table limit
          </small>
        </div>
      </div>

      {/* RIGHT */}
      <div className="modern-select-wrap">

        <select
          className="modern-rows-select"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>

        <span className="entries-text">
          entries
        </span>
      </div>
    </div>
  );
};

export default RowsPerPage;